import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import { Footer } from '../../Components/Footer/Footer'
import NewFooter from '../../Components/NewFooter/NewFooter'
import NewHome from '../../Components/NewHome/NewHome'

const NewHome2 = () => {
    return (
        <>
            <Navbar />
            <NewHome />
            <Footer />
        </>
    )
}

export default NewHome2